import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { MyStore } from '@thd-olt-component-react/my-store';
import {
  extend, useLazyDataModel, customType, string, params
} from '@thd-nucleus/data-sources';
import { localizeToProject } from './helpers';

export const MyStoreForm = ({
  projectId,
  projectName,
  assortmentZip,
  storeId,
  onUpdate,
  onStoreChangeSuccess
}) => {

  const [updateProjectDetails] = useLazyDataModel('updateProject', {
    variables: {
      projectId
    },
    refetchQueries: [
      'projectDetails'
    ],
    context: { withAuth: true }
  });

  const handleStoreChange = async (newStoreId) => {
    await updateProjectDetails({
      variables: {
        operationType: 'INFO',
        projectInfo: {
          projectName,
          preferredStore: newStoreId
        }
      }
    });
    
    localizeToProject({
      assortmentZip,
      preferredStore: newStoreId,
      onUpdate
    });

    if (onStoreChangeSuccess) {
      onStoreChangeSuccess(newStoreId);
    }
  };

  return (
    <MyStore storeId={storeId} customStoreHandler={handleStoreChange} />
  );
};

MyStoreForm.displayName = 'MyStoreForm';

MyStoreForm.propTypes = {
  projectId: PropTypes.string,
  projectName: PropTypes.string,
  assortmentZip: PropTypes.string,
  storeId: PropTypes.string,
  onUpdate: PropTypes.func,
  onStoreChangeSuccess: PropTypes.func
};

MyStoreForm.defaultProps = {
  projectId: '',
  projectName: '',
  assortmentZip: '',
  storeId: '',
  onUpdate: () => {},
  onStoreChangeSuccess: null
};

MyStoreForm.dataModel = extend(
  {
    updateProject: params({
      projectId: string().isRequired(),
      operationType: customType('OperationType').enum(['STATUS', 'INFO', 'ADDRESS']).isRequired(),
      projectInfo: customType('Info').shape({
        preferredStore: string()
      })
    }).mutation().shape({
      id: string()
    })
  },
  MyStore,
);
